// extracted by mini-css-extract-plugin
export default {"price":"c7-z","priceRow":"d7-z","onSale":"e7-z","msrpLabelPrice":"f7-z","msrpLabel":"g7-z","originalPrice":"h7-z","percentOff":"i7-z"};